import { render, staticRenderFns } from "./SolicitarItem.vue?vue&type=template&id=465d22de"
import script from "./SolicitarItem.vue?vue&type=script&lang=js"
export * from "./SolicitarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports